<ng-container *ngIf="showModal">
    <div class="modal-content">
        <div class="text-center">
            <h3> <b>{{titulo}}</b></h3>
        </div>
        <p> A Secretaria de Educação Profissional e Tecnológica do Ministério da Educação esclarece que, embora conste
            na capa da versão em PDF do Catálogo Nacional de Cursos Técnicos a data de atualização de 27/02/2024, <b>não
                houve atualização do conteúdo do Catálogo nesse período</b>. A mudança na data está relacionada a um
            <b>processo de aprimoramento da infraestrutura tecnológica do portal</b>.
        </p>
        <p>
            O Catálogo Nacional de Cursos Técnicos disponibilizado em nosso portal <b>foi aprovado pela Resolução
                CNE/CEB nº 2/2020 e encontra-se em sua 4ª edição</b>. Entre março de 2022 até março de 2023, foram
            realizados apenas ajustes pontuais, os quais estão registrados na planilha de <a
                href="https://cnct.mec.gov.br/cnct-api/relatorio-dados-atualizadospdf"
                rel="nofollow noreferrer noopener" target="_blank">Registro de Alterações no Portal</a>, acessível por
            meio do menu principal.</p>
        <p>
            Portanto, reiteramos que não houve nenhum ajuste no Catálogo desde março de 2023. <b>A versão atual é a 4ª
                edição, de 2020</b>, e a data de 27/02/2024 na versão em PDF <b>não reflete alterações no conteúdo</b>
            do Catálogo nesse período.</p>
        <div class="text-center">
            <button class="btn-xl" (click)="toggle()">Ok</button>
        </div>
    </div>
    <div class="modal-overlay"></div>
</ng-container>